import React from 'react';
import { Modal } from 'antd';

const ModelPanel = ({ open, onClose, data }) => {
    return (
        <Modal
            title={data?.heading || 'Project Details'}
            open={open}
            onCancel={onClose}
            footer={null}
        >
            {data?.url && (
                <a href={data.url} target="_blank" rel="noopener noreferrer">
                    Visit Site
                </a>
            )}
            {data?.tag && <p><strong>Tag:</strong> {data.tag}</p>}
        </Modal>
    );
};

export default ModelPanel;